import { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import ViewCalculation from 'esr-core/view_calculation';
import './ViewCalculationBaywa.css';

const MAILTO_TO = 'baudienstleistungen@baywa.de';
const MAILTO_SUBJECT = 'Kontaktanfrage BayWa Baustoffe zu Ergebnissen des Energiesparrechners';

export default function ViewCalculationBaywa() {
    const [pdfUrl, setPdfUrl] = useState('');
    const [portalTarget, setPortalTarget] = useState<Element | null>(null);

    useEffect(() => {
        const target = document.querySelector('.view-dialog-inner');
        setPortalTarget(target);

        const pdfLink = document.querySelector<HTMLElement>('a.pdf-link');
        if (pdfLink) {
            setPdfUrl(pdfLink.getAttribute('href') ?? '');
            pdfLink.style.display = 'none';
        }
    }, []);

    const handleSendClick = async () => {
        let linkUrl = pdfUrl;
        try {
            const url = new URL(pdfUrl);
            const params: Record<string, string> = {};
            url.searchParams.forEach((value, key) => { params[key] = value; });
            const saveUrl = url.origin + url.pathname.replace(/\/?$/, '/') + '?action=save';
            const res = await fetch(saveUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(params),
            });
            const { id } = await res.json();
            linkUrl = url.origin + url.pathname + '?id=' + id;
        } catch (_) {
            // fallback: use full pdfUrl
        }
        const body =
            'Sehr geehrte Damen und Herren,\n\n' +
            'meine Ergebnisse des Energiesparrechners finden Sie unter diesem Link:\n\n' +
            linkUrl +
            '\n\nBitte nehmen Sie für ein Beratungsgespräch Kontakt mit mir auf.';
        window.location.href =
            'mailto:' + MAILTO_TO +
            '?subject=' + encodeURIComponent(MAILTO_SUBJECT) +
            '&body=' + encodeURIComponent(body);
    };

    const buttonRow = pdfUrl ? (
        <div className="baywa-button-row">
            <a
                className="pdf-link"
                href={pdfUrl}
                target="_blank"
                role="button"
                aria-label="Bericht anzeigen"
                tabIndex={0}
            >
                Bericht anzeigen
            </a>
            <button
                id="new-button"
                type="button"
                className="pdf-link baywa-send-btn"
                onClick={handleSendClick}
            >
                Bericht senden<br />und Kontakt aufnehmen
            </button>
        </div>
    ) : null;

    return (
        <>
            <ViewCalculation />
            {portalTarget && buttonRow && createPortal(buttonRow, portalTarget)}
        </>
    );
}
